import { Settings, CalendarCheck, Users2 } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CircleSettings } from "./CircleSettings";
import { CircleEventsList } from "./CircleEventsList";
import { CircleStatsCard } from "./CircleStatsCard";
import { CircleUsersSection } from "./CircleUsersSection";

export function CircleTab() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold text-foreground">Circle Management</h2>
          <p className="text-sm text-muted-foreground">
            Manage community-driven casual events
          </p>
        </div>
      </div>

      <CircleStatsCard />

      <Card>
        <CardHeader className="pb-4">
          <CardTitle className="flex items-center gap-2 text-lg">
            <Settings className="w-5 h-5" />
            Settings
          </CardTitle>
        </CardHeader>
        <CardContent>
          <CircleSettings />
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-4">
          <CardTitle className="flex items-center gap-2 text-lg">
            <CalendarCheck className="w-5 h-5" />
            Events
          </CardTitle>
        </CardHeader>
        <CardContent>
          <CircleEventsList />
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-4">
          <CardTitle className="flex items-center gap-2 text-lg">
            <Users2 className="w-5 h-5" />
            Users
          </CardTitle>
        </CardHeader>
        <CardContent>
          <CircleUsersSection />
        </CardContent>
      </Card>
    </div>
  );
}
